import React from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import Pillars from '../components/landing/Pillars';
import Cards from '../components/landing/Cards';
import HowItWorks from '../components/landing/HowItWorks';
import Loyalty from '../components/landing/Loyalty';
import Business from '../components/landing/Business';
import MobileApp from '../components/landing/MobileApp';
import Partners from '../components/landing/Partners';
import FAQ from '../components/landing/FAQ';
import Contact from '../components/landing/Contact';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Pillars />
        <Cards />
        <HowItWorks />
        <Loyalty />
        <Business />
        <MobileApp />
        <Partners />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
